// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@par/app/core/services/config.service';
import { MediaGroupsResponse } from '@par/app/shared/select-media-group/models/media-groups-list-response';

@Injectable({
  providedIn: 'root',
})
export class MediaGroupService {

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  getGroups(): Observable<MediaGroupsResponse> {
    const url = this.configService.getConfig().kknowContentApi + '/publication/groups';
    return this.httpClient.get<MediaGroupsResponse>(url);
  }
}
